import { BeeTableColumn } from "./bee-table-column";

export class BeeTableSettings<T> {
  data: T;
  columns: BeeTableColumn[];
}
  